import { defineMessages, MessageDescriptor } from 'react-intl';

import { OrganizationKindSelectValue } from './types';

export const organizationKindMessages: Record<
  OrganizationKindSelectValue,
  MessageDescriptor
> = defineMessages({
  all: {
    id: 'organizations.filter.all',
    defaultMessage: 'All',
  },
  ShowDistributors: {
    id: 'organizations.filter.distributors',
    defaultMessage: 'Distributors',
  },
  ShowDistributorClients: {
    id: 'organizations.filter.distributorClients',
    defaultMessage: 'Distributor Clients',
  },
  ShowDSOs: {
    id: 'organizations.filter.dsos',
    defaultMessage: 'DSOs',
  },
  ShowDSOClients: {
    id: 'organizations.filter.dsoClients',
    defaultMessage: 'DSO Clients',
  },
});
